<template>
    <div class="col-sm-6 col-md-6">
        <h2 style="font-size: 28px;">{{ title_legalnotices[getCurrentLocale] }}</h2>
        <ul class="discover triangle hover row">
            <li class="col-xs-6">
                <a href="#" v-on:click.prevent="call_getwebcomponent('AGB')" style="color: #fefe00; font-size: 18px;">{{ listpoint_agb[getCurrentLocale] }}</a>
            </li>
            <li class="col-xs-6">
                <a href="#" v-on:click.prevent="call_getwebcomponent('ABB')" style="color: #fefe00; font-size: 18px;">{{ listpoint_abb[getCurrentLocale] }}</a>
            </li>
            <li class="col-xs-6">
                <a href="#" v-on:click.prevent="call_getwebcomponent('IMPRINT')" style="color: #fefe00; font-size: 18px;">{{ listpoint_impressum[getCurrentLocale] }}</a>
            </li>
            <li class="col-xs-6">
                <!-- <a href="/infos-privacy-policy/#/privacy-policy" v-bind:class="{ active: getPathName('infos-privacy-policy') }">{{ infosprivacypolicy[getCurrentLocale] }}</a> -->
                <a href="#" v-on:click.prevent="call_getwebcomponent('PCPE')" style="color: #fefe00; font-size: 18px;">{{ infosprivacypolicy[getCurrentLocale] }}</a>
            </li>
        </ul>



        <!-- <br />
        <h2>{{ title_career[getCurrentLocale] }}</h2>
        <p>
            <a href="/career/" v-bind:class="{ active: getPathName('career') }">{{ careertext[getCurrentLocale] }}</a>
        </p> -->



        <!-- <br />
        <h2>{{ title_press[getCurrentLocale] }}</h2>
        <p>
            <span v-for="(pressrelease) in get_PressreleasesHeadlines_Filtered.slice(0, 6)" v-bind:key="pressrelease.id">
                <a href="/pressreleases/" >{{ pressrelease.publishDate | nicedate }} - {{ pressrelease.headline | truncate }}</a><br />
            </span>
        </p> -->










        <!-- >>> Modal - Modal - Modal - Modal - Modal - Modal - Modal - Mod -->
        <!-- >>> Modal - Modal - Modal - Modal - Modal - Modal - Modal - Mod -->
        <modal name="size-modal"
                transition="nice-modal-fade"
                classes="demo-modal-class"
                :min-width="200"
                :min-height="200"
                :pivot-y="0.5"
                :adaptive="true"
                :scrollable="true"
                :reset="true"
                height="auto"
                @before-open="beforeOpen"
                @opened="opened"
                @closed="closed"
                @before-close="beforeClose">
                <div class="size-modal-content">
                    <h2>{{ webcomponenttype }}</h2>
                    <span v-if="sections.length > 1">
                        <div class="toggle-container box" id="accordion1" v-for="(section, index) in sections" :key="index" style="margin-bottom:0px;">
                            <div class="panel style1">
                                <h4 class="panel-title">
                                    <a class="collapsed" v-bind:href="'#acc1_' + index" data-toggle="collapse" data-parent="#accordion1">{{ section.title }}</a>
                                </h4>
                                <div class="panel-collapse collapse" v-bind:id="'acc1_' + index">
                                    <div class="panel-content">
                                        <span v-html="section.content"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </span>

                    <span v-if="sections.length === 1">
                        <div class="panel style1">
                            <span v-html="sections[0].content"></span>
                        </div>
                    </span>
                </div>
        </modal>
    </div>
</template>

<script>
    import axios from 'axios';

    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';

	import { query } from 'gql-query-builder';// Graphql

    import moment from 'moment';


    export default {

        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                listpoint_agb: {
                    en: 'General Terms',
                    de: 'AGB',
                },
                listpoint_abb: {
                    en: 'Terms and Conditions',
                    de: 'ABB',
                },
                listpoint_impressum: {
                    en: 'Imprint',
                    de: 'Impressum',
                },
                listpoint_sec: {
                    en: 'Data Protection & Privacy',
                    de: 'Datenschutz',
                },
                infosprivacypolicy: {
                    en: 'Data Protection & Privacy',
                    de: 'Datenschutz',
                },
                title_legalnotices: {
                    en: 'Legal Notices',
                    de: 'Rechtliche Hinweise',
                },
                title_career: {
                    en: 'Career',
                    de: 'Karriere',
                },
                careertext: {
                    en: 'Learn more about open positions at SUNDAIR. Become a part of our team as well.',
                    de: 'Mehr über offene Positionen bei SUNDAIR erfahren. Werden Sie auch ein Teil unseres Teams.',
                },
                title_press: {
                    en: 'Press',
                    de: 'Presse',
                },
                listpoint_faq : {
                    en: 'Faq',
                    de: 'Faq',
                },
                // currentLocale: 'de',
                // >>> -------------------------- Modal
                webcomponenttype: '', // ABB/FAQ aso.
                sections: [], // data
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                'get_PressreleasesHeadlines_Filtered'
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Filters */
        filters: {

            /*******************************************************************
            * nicedate()
            *
            * Desc:
            *
            * @param {string} date (Date to reformat)
            * @return {string}
            */
            nicedate: function(date) {

                return moment(date, moment.ISO_8601).format('DD.MM.YYYY'); // de:

            }, // eo function nicedate()


            /*******************************************************************
            * truncate()
            *
            * Desc:
            *
            * @param {string}
            * @return {string}
            */
            truncate: function(str) {

                let n = 35;


                return (str.length > n) ? str.substr(0, n-1) + '...' : str;

            } // eo function truncate()

        }, // eo filters{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc: Load 'Pressreleases' Headlines.
        * Note:
        *
        */
		created: function() {

            let me = this,
				params = query({
					operation: 'pressreleases',
					fields: [
						'_id', 'publishDate', 'headline', 'active',
					]
				});


            me.$toc('>>> shared/footer/SecondRow.vue >>> created');
			// >>> ---------------------------------------- Call
			me.actn_call_getPressreleasesHeadlines(params);

		}, // eo function created()
		/* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

			...mapActions([
				'actn_call_getPressreleasesHeadlines',
			]),


            /******************************************************************* 'ServiceCalls - Common'
            * ServiceCalls:
            *******************************************************************/
            /*******************************************************************
            * Call::'/site/getwebcomponent/'
            *
            * Desc:
            * Note:
            *
            * @param {string} comptype (kind of Component)
            * @param
            * @return
            */
            call_getwebcomponent: function (comptype) {

                var me = this,
                    hdrs = '';


                me.$toc('>>> shared/footer/SecondRow.vue >>> call_getwebcomponent');
                // >>> 1. Builds Object ----------------------------------------
                const requestParamObject = {
                    name: comptype
                };


                // >>> #267, Translation ---------------------------------------
                if (comptype === 'ABB') {
                    this.webcomponenttype = this.listpoint_abb[this.getCurrentLocale];
                }  else if (comptype === 'AGB') {
                    this.webcomponenttype = this.listpoint_agb[this.getCurrentLocale];
                }  else if (comptype === 'IMPRINT') {
                    this.webcomponenttype = this.listpoint_impressum[this.getCurrentLocale];
                }  else if (comptype === 'PCPE') {
                    this.webcomponenttype = this.listpoint_sec[this.getCurrentLocale];
                }  else if (comptype === 'FAQ') {
                    this.webcomponenttype = this.listpoint_faq[this.getCurrentLocale];
                } else {
                    this.webcomponenttype = comptype; // remember
                }


                // >>> Send Ajax Request ---------------------------------------
                me.$vp_m();
                axios.put('/site/getwebcomponent/', requestParamObject)
                    .then(function(response) { // 'OK'
                        hdrs = response.headers["air41-status"];
                        switch (hdrs) {
                            case 'OK': // 'OK'
                                me.$modal.show('size-modal', { data: response.data });
                                me.$vp_um();
                                break;
                            default: // 'ERROR'
                                me.$toasted.global.sdr_app_error({
                                    message : response.headers["air41-error"]
                                });
                                break;
                        };
                    })
                    .catch(function(error) { // 'ERROR'
                        me.$vp_um();
                        me.$toasted.global.sdr_app_error({
                            message : 'Service unavailable'
                        });
                    });

            }, // eof call_getwebcomponent()




            /******************************************************************* 'Utilities - Common'
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * getPathName()
            *
            * Desc:
            * Note:
            *
            * @param {string} pathname ()
            * @param
            * @return
            */
            getPathName: function (pathname) {

                var me = this,
                    currentUrl = window.location.pathname,
                    currentUrl = currentUrl.slice(1,-1);


                // me.$toc('>>> shared/footer/LanguageList.vue >>> getPathName');
                if (pathname === currentUrl) {
                    return true;
                } else {
                    return false;
                }

            }, // eof getPathName()




            /*******************************************************************
            * Modals:
            *******************************************************************/
            /*******************************************************************
            * Modal - Events - beforeOpen
            *
            * Desc:
            * Note: Catches 'data' Object from $modal.show.
            *
            */
            beforeOpen (event) {

                this.sections = event.params.data.sections;

            }, // eof beforeOpen()

            /*******************************************************************
            * Modal - Events - beforeClose
            *
            * Desc:
            * Note:
            *
            */
            beforeClose () {

                this.sections = [];

            }, // eof beforeClose()

        }, // eof methods()
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    /* Modal */
    .size-modal-content {
        padding: 10px;
        font-style: 13px;
        background-color: rgb(255, 255, 255);
        padding-right: 50px;
    }
    .v--modal-overlay[data-modal="size-modal"] {
        background: rgba(0, 0, 0, 0.5);
        z-index: 555555 !important;

    }
    .demo-modal-class {
        border-radius: 5px;
        background: #F7F7F7;
        box-shadow: 5px 5px 30px 0px rgba(46,61,73, 0.6);
    }
</style>


// WEBPACK FOOTER //
// src/components/shared/footer/SecondRow.vue